import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CadCadastroContato } from 'app/shared/interfaces/cad-cadastro-contato';
import { PageResult } from 'app/shared/interfaces/page-result';
import { ContatoPopupComponent } from '../contato-popup/contato-popup.component';

/**
 * Lista de contatos de um cadastro — mesma estrutura da lista de endereços: cards no celular,
 * ngx-datatable no desktop, e o form em popup separado que grava por conta própria.
 */
@Component({
  selector: 'app-cadastro-contato-popup',
  templateUrl: './cadastro-contato-popup.component.html',
  styleUrls: ['./cadastro-contato-popup.component.scss']
})
export class CadastroContatoPopupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: false }) paginatorContato: MatPaginator;

  layoutConf: any;
  pageObjectContato$: BehaviorSubject<PageResult<CadCadastroContato>> =
    new BehaviorSubject<PageResult<CadCadastroContato>>(null);
  contatos: CadCadastroContato[];
  pageContato = 1;
  lengthContato = 0;
  pageSizeContato = 5;
  pageEventContato = null;
  pageSizeOptionsContato: number[] = [5, 10, 25];
  cadastro: Cadastro;
  dialogRefContato: MatDialogRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CadastroContatoPopupComponent>,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private loader: AppLoaderService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.cadastro = this.data.payload;

    this.pageObjectContato$.subscribe(page => {
      if (page != null) {
        this.contatos = page.content;
        this.lengthContato = page.totalElements;
        this.pageSizeContato = page.size;
        this.pageContato = page.number;
        if (this.pageContato === 1 && this.paginatorContato) {
          this.paginatorContato.firstPage();
        }
      } else {
        this.contatos = [];
      }
    });

    this.getPageContato(this.pageContato, this.pageSizeContato, this.cadastro?.id);
  }

  getPageContato(page: number, pageSize: number, id: number) {
    if (id !== undefined) {
      this.cadastroService.getPageContato(page, pageSize, id.toString())
        .subscribe(val => { this.pageObjectContato$.next(val) });
    }
  }

  reloadPageContato() {
    this.pageContato = 1;
    this.getPageContato(this.pageContato, this.pageSizeContato, this.cadastro?.id);
  }

  deleteContato(data: any = {}) {
    const descricao = data?.nome || 'contato';
    this.confirmService.confirm({ message: `Deletar ${descricao}?` })
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroService.deleteCadastroContato(data.id).subscribe({
          next: retorno => {
            this.loader.close();
            this.confirmService.confirm({
              title: retorno.status ? 'Sucesso' : 'Erro',
              message: retorno.status
                ? `Contato ${descricao} deletado!`
                : `Erro ao deletar ${descricao} (há dependências).`,
              error: !retorno.status
            });
            if (retorno.status) {
              this.getPageContato(1, this.pageSizeContato, this.cadastro?.id);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.loader.close();
            const message = error?.status === 404
              ? `Contato ${descricao} não encontrado para exclusão.`
              : `Erro ao deletar ${descricao}.`;
            this.confirmService.confirm({ title: 'Erro', message, error: true });
          }
        });
      });
  }

  popUpContato(data: any = {}, isNew?) {
    const title = isNew ? 'Novo Contato' : 'Alterar Contato';
    if (isNew) {
      data.cadastroId = this.cadastro?.id;
      // Primeiro contato herda o telefone e o e-mail do cadastro: e o caso comum de quem cadastra
      // a empresa e o proprio contato dela.
      if (!this.contatos || this.contatos.length === 0) {
        data = {
          ...data,
          telefone: this.cadastro?.celular ?? this.cadastro?.telefone1,
          email: this.cadastro?.email,
        };
      }
    } else {
      data.cadastroId = data?.cadastroId ?? this.cadastro?.id;
    }

    this.dialogRefContato = this.dialog.open(ContatoPopupComponent, {
      width: this.layoutConf?.isMobile ? '100vw' : '80%',
      maxWidth: '100vw',
      height: this.layoutConf?.isMobile ? '100dvh' : undefined,
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: this.layoutConf?.isMobile ? ['dialog-fullscreen'] : undefined,
      data: { title: title, payload: data }
    });

    this.dialogRefContato.afterClosed().subscribe(() => this.reloadPageContato());
  }

  setPageSizeOptionsContato(event: PageEvent) {
    this.pageSizeContato = event.pageSize;
    this.getPageContato(event.pageIndex + 1, event.pageSize, this.cadastro?.id);
  }

  close() {
    this.dialogRef.close();
  }
}
